import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { PartialFiltersMatch } from 'components/HotelCard/PartialFiltersMatch/PartialFiltersMatch';
import { HotelCardContext } from 'components/HotelCardContext';
import { getHotel, getSearchType, State } from 'modules/sapiSearch/selectors';
import { SearchType } from 'modules/sapiSearch/utils';
import { getIsSortByDistance, getIsUserOrUrlLocationSearch } from 'modules/search/selectors';
import { Box } from '@daedalus/atlas/helpers/Box';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { StarRating } from '@daedalus/atlas/StarRating';
import { Text } from '@daedalus/atlas/Text';
import { ReviewRating } from '@daedalus/shared/src/search/ReviewRating';
import { HotelDistance } from '../HotelDistance';
import { HotelLocation } from '../HotelLocation';
const _exp = /*#__PURE__*/() => Text;
export const HotelName = /*#__PURE__*/styled(_exp())({
  name: "HotelName",
  class: "hx39p6t",
  propsAsIs: true
});
export const PropertyDetails = () => {
  const {
    hotelId
  } = useContext(HotelCardContext);
  const hotelDetails = useSelector((state: State) => getHotel(state, hotelId));
  const searchType = useSelector(getSearchType);
  const isUserOrUrlLocationSearch = useSelector(getIsUserOrUrlLocationSearch);
  const isSortByDistance = useSelector(getIsSortByDistance);
  const isLoading = !hotelId || !hotelDetails;
  if (isLoading) {
    return <Box>
        <SkeletonLoader height={16} width={88} />
        <SkeletonLoader height={28} width={127} />
        <SkeletonLoader height={16} width={161} />
        <SkeletonLoader height={16} width={99} />
      </Box>;
  }
  return <Box display="flex" flexDirection="column" overflow="hidden">
      <Box paddingRight="s400" paddingBottom="s200">
        <div data-id="StarRating">
          <StarRating wrapperId={`HotelCardMobileStarRating-${hotelId}`} rating={hotelDetails.starRating} size="xs" />
        </div>
        <HotelName id={`HotelCardMobileHotelName-${hotelId}`} data-id="HotelName" variant="titleL" tag="h2">
          {hotelDetails.hotelName}
        </HotelName>
        <Box data-id="LocationDetails" marginTop="s100" marginBottom="s200">
          {searchType === SearchType.Area || isUserOrUrlLocationSearch || isSortByDistance ? <HotelDistance /> : <HotelLocation hotelDetails={hotelDetails} />}
        </Box>
        <ReviewRating variant="compact" rating={hotelDetails.guestRating.overall} totalRatingCount={hotelDetails.reviewCount} hotelId={hotelDetails.objectID} dataId="ReviewRating" />
      </Box>
      <PartialFiltersMatch hasBasicPropertyDetails={false} />
    </Box>;
};

require("./PropertyDetails.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PropertyDetails.tsx");